import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import PrimaryPatient from './components/PrimaryPatient/PrimaryPatient';
import SignIn from './components/SignIn/SignIn';
import PrivateRoutes from './utils/PrivateRoutes';
import { ToastContainer } from 'react-toastify';

// import 'react-toastify/dist/ReactToastify.css';
import ResetPassword from './components/ResetPassword/ResetPassword';
import SenyoError from './components/SenyoError/SenyoError';
import VideoListPage from './pages/VideoListPage';
import VideoDetailPage from './pages/VideoDetailPage';
//
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/forgotpassword' element={<ForgotPassword />} />
          <Route path='/signin' element={<SignIn />} />
          <Route path='/resetpassword' element={<ResetPassword />} />
          <Route path='/senyoError' element={<SenyoError />} />
          <Route element={<PrivateRoutes />}>
            <Route path='/' element={<PrimaryPatient />} />
            <Route path="/videos" element={<VideoListPage />} />
            <Route path="/videos/:videoId" element={<VideoDetailPage />} />
          </Route>
        </Routes>
      </Router>
      <ToastContainer
        position='top-center'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
